<!-- 시청예약 알림 팝업 리스트 -->
<template>
  <div v-if="!!dataList.length" class="my-pop-alert-body">
    <div id="popupScroll" class="popup-scroll">
      <ul class="alarm-list">
        <li v-for="(data, index) in dataList" :key="index" :index="index">
          <div class="image-area">
            <img :src="getImage(data.image)" alt="" />
          </div>
          <div class="text-area">
            <span class="program-title">{{ data.contenttitle }}</span>
            <span class="program-metadata">{{ data.releasedatetime }}</span>
            <span class="program-metadata">{{ data.channeltitle }}</span>
          </div>
          <div class="time-alarm">
            <span class="check-time">
              <btn-live-alarm
                class="live-view-ch"
                is-on="y"
                :target-date="data.releasedatetime"
                :contents-id="data.contentid"
                :content-type="data.contenttype"
                :game-id="data.gameid"
                :content-title="data.contenttitle"
              />
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div v-else class="my-pop-alert-empty">
    <template v-if="!isLoading">
      <exclamation-circle-icon />
      <p>시청 예약 내역이 없어요</p>
    </template>
  </div>
</template>

<script>
  import { getAlarmsContent } from '@/common/utils/request'
  import _ from 'lodash'
  import BtnLiveAlarm from '@/components/button/BtnLiveAlarm'
  import { ExclamationCircleIcon } from '@/components/Icons'
  import { resizeThumbnail } from '@/common/utils/image'

  export default {
    components: {
      BtnLiveAlarm,
      ExclamationCircleIcon,
    },
    data() {
      return {
        dataList: [],
        offset: 0,
        limit: 10,
        isLoading: true,
        isError: false,
        endOfList: false,
        scrollEl: null,
        listEl: null,
      }
    },
    created() {
      this.setData()
    },
    beforeDestroy() {
      const scrollPane = document.querySelector('#popupScroll')
      scrollPane?.removeEventListener('scroll', this.scrollEvent)
    },
    methods: {
      getImage(img) {
        return resizeThumbnail(img, {
          width: 0,
          height: 0,
          option: 20,
          quality: 80,
        })
      },
      loadMore() {
        this.setData()
      },
      scrollEvent: _.throttle(function (e) {
        if (this.endOfList) return
        const listEl = e.target.querySelector('.alarm-list')
        const leftBottom =
          e.target.getBoundingClientRect().bottom -
          listEl.getBoundingClientRect().bottom
        if (leftBottom > 0 && leftBottom < 37) {
          this.loadMore()
        }
      }, 100),
      setData() {
        this.loading = true
        const getData = (response) => response.data
        const setList = (data) => {
          const newList = _.get(data, 'list', [])
          if (newList.length === 0) {
            this.endOfList = true
            return
          }
          this.dataList = this.dataList.concat(newList)
          return data
        }
        const setEndOfList = (data) => {
          this.endOfList = _.get(data, 'list', []).length === 0
          return data
        }
        const setOffset = (data) => {
          this.offset += this.limit
          return data
        }
        const loadComplete = () => {
          this.isLoading = false
        }
        getAlarmsContent({
          contenttype: 'live',
          offset: this.offset,
          limit: this.limit,
        })
          .then(getData)
          .then(setList)
          .then(setEndOfList)
          .then(setOffset)
          .then(loadComplete)
          .then(() => {
            this.$nextTick(() => {
              if (this.scrollEl === null) {
                const scrollPane = document.querySelector('#popupScroll')
                scrollPane?.addEventListener('scroll', this.scrollEvent)
              }
            })
          })
      },
    },
  }
</script>

<style lang="css" scoped>
  .my-pop-alert-body .popup-scroll {
    position: relative;
    height: 646px;
    overflow-y: scroll;
    margin: 36px 0 0 0;
    padding: 0 20px 36px 36px;
  }

  .alarm-popup .my-pop-alert-empty {
    height: auto;
    padding: 286px 0;
  }

  .alarm-list {
    font-size: 0;
    text-align: left;
  }

  .alarm-list > li {
    display: flex;
    align-items: center;
  }

  .alarm-list > li + li {
    margin-top: 20px;
  }

  .alarm-list > li > div {
    display: inline-block;
    vertical-align: middle;
  }

  .alarm-list .image-area {
    position: relative;
    overflow: hidden;
    width: 160px;
    height: 90px;
    background-color: #2f2f2f;
    border-radius: 12px;
  }

  .alarm-list .image-area img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: auto;
  }

  .alarm-list .text-area {
    flex: 1;
    padding: 0 12px 0 20px;
  }

  .alarm-list .text-area span {
    display: block;
    color: #a5a5a5;
  }

  .alarm-list .text-area span + span {
    margin-top: 4px;
  }

  .alarm-list .program-title {
    font-size: 16px;
    line-height: 24px;
  }

  .alarm-list .program-metadata {
    font-size: 14px;
    line-height: 20px;
  }
</style>
